// extracted by mini-css-extract-plugin
export var bordertop = "ParagraphHighlightedQuotes-module--bordertop--35737";
export var content = "ParagraphHighlightedQuotes-module--content--f0703";
export var paragraphhighlightedquotesinner = "ParagraphHighlightedQuotes-module--paragraphhighlightedquotesinner--43415";
export var paragraphhighlightedquotesouter = "ParagraphHighlightedQuotes-module--paragraphhighlightedquotesouter--004ed";
export var quote = "ParagraphHighlightedQuotes-module--quote--c43b0";
export var quotee = "ParagraphHighlightedQuotes-module--quotee--7eb20";
export var quoteerole = "ParagraphHighlightedQuotes-module--quoteerole--f9e3c";
export var quotemarks = "ParagraphHighlightedQuotes-module--quotemarks--32bf5";
export var quotetext = "ParagraphHighlightedQuotes-module--quotetext--8081d";